import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from './CookieBanner';
import LoadingScreen from './LoadingScreen';
import { Toaster } from 'sonner';

const Layout = ({ children }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      if (e.matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };

    handleChange(mediaQuery);
    mediaQuery.addEventListener('change', handleChange);
    
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Mostra loading screen solo al primo caricamento
  useEffect(() => {
    if (!hasLoaded) {
      const alreadyLoaded = sessionStorage.getItem('faccioapp_loaded');
      if (alreadyLoaded) {
        setIsLoading(false);
        setHasLoaded(true);
      }
    }
  }, [hasLoaded]);

  const handleLoadingComplete = () => {
    setIsLoading(false);
    setHasLoaded(true);
    sessionStorage.setItem('faccioapp_loaded', 'true');
  };

  return (
    <div className="min-h-screen bg-[var(--color-bg)] flex flex-col">
      {isLoading && !hasLoaded && <LoadingScreen onComplete={handleLoadingComplete} />}
      <Toaster 
        position="top-right" 
        richColors 
        toastOptions={{ 
          duration: 4000,
          style: { zIndex: 9999 }
        }} 
        containerStyle={{ top: 80, right: 16, zIndex: 9999 }}
      />
      <Header />
      <main className="flex-1 pt-16 md:pt-20">
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Layout;
